module.exports = __webpack_public_path__ + "UNIS.7c0c286b6d564d0ae2a47f315591da7d.png";